import { Receipt } from "@mui/icons-material";
import AddHomeWorkSharpIcon from "@mui/icons-material/AddHomeWorkSharp";
import FingerprintOutlinedIcon from "@mui/icons-material/FingerprintOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MasksIcon from "@mui/icons-material/Masks";
import PostAddIcon from "@mui/icons-material/PostAdd";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { Button } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../assets/openIMIS.png";
import {
  ADMIN_USERS,
  ADMIN_USER_FORM,
  ADMIN_USER_FORM_BY_ID,
  CLAIM_PORTAL,
  FOSA_VERIFICATION,
  HAS_PERMISSION_TO_VIEW_PAGE,
  HEALTH_FACILITY,
  HOME_PAGE,
  INVOICE_URL,
  PATH_NAME_PERMISSIONS,
  Pre_Autharization,
  Pre_Autharization_Form,
  STAFF_MANAGEMENT,
} from "../../../utils/constant";
import "./Sidebar.scss";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.profileReducer);
  const fosaInfo = useSelector((state) => state.fosaReducer);
  const isFosa = userInfo?.currentUserResponseData?.i_user?.health_facility_id;
  const fosaPermission = fosaInfo?.fosaUserData?.[0]?.iUser;
  const currentUserRoles = useSelector(
    (state) => state.profileReducer.currentUserRoles?.roles
  );

  // Parse fosaEmpPermissions
  const fosaEmpPermissions = fosaPermission?.fosaEmpPermissions
    ? fosaPermission.fosaEmpPermissions.split(",").map(Number)
    : [];

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        <div className="logo-container" onClick={() => navigate(HOME_PAGE)}>
          <img src={logo} alt="Logo" className="logo" />
        </div>
      </div>
      <ul className="menu-items">
        {!!isFosa && (
          <>
            <li
              className={
                location.pathname.includes(HEALTH_FACILITY) ? "active" : ""
              }
              onClick={() => navigate(HEALTH_FACILITY)}
            >
              <Button startIcon={<AddHomeWorkSharpIcon />}>
                {t("healthFacility")}
              </Button>
            </li>
            {!!fosaPermission?.isFosaEmp ? (
              <>
                {fosaEmpPermissions.includes(1) &&
                  HAS_PERMISSION_TO_VIEW_PAGE(
                    PATH_NAME_PERMISSIONS,
                    CLAIM_PORTAL,
                    currentUserRoles
                  ) && (
                    <li
                      className={
                        location.pathname.includes(CLAIM_PORTAL) ? "active" : ""
                      }
                      onClick={() => navigate(CLAIM_PORTAL)}
                    >
                      <Button startIcon={<PostAddIcon />}>
                        {t("claimTitle")}
                      </Button>
                    </li>
                  )}
                {fosaEmpPermissions.includes(2) &&
                  HAS_PERMISSION_TO_VIEW_PAGE(
                    PATH_NAME_PERMISSIONS,
                    STAFF_MANAGEMENT,
                    currentUserRoles
                  ) && (
                    <li
                      className={
                        location.pathname.includes(STAFF_MANAGEMENT)
                          ? "active"
                          : ""
                      }
                      onClick={() => navigate(STAFF_MANAGEMENT)}
                    >
                      <Button startIcon={<ManageAccountsIcon />}>
                        {t("StaffManagement")}
                      </Button>
                    </li>
                  )}
                {fosaEmpPermissions.includes(3) &&
                  HAS_PERMISSION_TO_VIEW_PAGE(
                    PATH_NAME_PERMISSIONS,
                    FOSA_VERIFICATION,
                    currentUserRoles
                  ) && (
                    <li
                      className={
                        location.pathname.includes(FOSA_VERIFICATION)
                          ? "active"
                          : ""
                      }
                      onClick={() => navigate(FOSA_VERIFICATION)}
                    >
                      <Button startIcon={<FingerprintOutlinedIcon />}>
                        {t("verificationTitle")}
                      </Button>
                    </li>
                  )}
                <li
                  className={
                    location.pathname.includes(Pre_Autharization)
                      ? "active"
                      : ""
                  }
                  onClick={() => navigate(Pre_Autharization)}
                >
                  <Button startIcon={<FingerprintOutlinedIcon />}>
                    {t("Accords Préalables")}
                  </Button>
                </li>
              </>
            ) : (
              <>
                {HAS_PERMISSION_TO_VIEW_PAGE(
                  PATH_NAME_PERMISSIONS,
                  INVOICE_URL,
                  currentUserRoles
                ) && (
                  <li
                    className={
                      location.pathname.includes(INVOICE_URL) ? "active" : ""
                    }
                    onClick={() => navigate(INVOICE_URL)}
                  >
                    <Button startIcon={<Receipt />}>
                      {t("paymentRequestsTitle")}
                    </Button>
                  </li>
                )}

                {HAS_PERMISSION_TO_VIEW_PAGE(
                  PATH_NAME_PERMISSIONS,
                  CLAIM_PORTAL,
                  currentUserRoles
                ) && (
                  <li
                    className={
                      location.pathname.includes(CLAIM_PORTAL) ? "active" : ""
                    }
                    onClick={() => navigate(CLAIM_PORTAL)}
                  >
                    <Button startIcon={<PostAddIcon />}>
                      {t("claimTitle")}
                    </Button>
                  </li>
                )}

                {HAS_PERMISSION_TO_VIEW_PAGE(
                  PATH_NAME_PERMISSIONS,
                  STAFF_MANAGEMENT,
                  currentUserRoles
                ) && (
                  <li
                    className={
                      location.pathname.includes(STAFF_MANAGEMENT)
                        ? "active"
                        : ""
                    }
                    onClick={() => navigate(STAFF_MANAGEMENT)}
                  >
                    <Button startIcon={<MasksIcon />}>
                      {t("StaffManagement")}
                    </Button>
                  </li>
                )}

                {HAS_PERMISSION_TO_VIEW_PAGE(
                  PATH_NAME_PERMISSIONS,
                  FOSA_VERIFICATION,
                  currentUserRoles
                ) && (
                  <li
                    className={
                      location.pathname.includes(FOSA_VERIFICATION)
                        ? "active"
                        : ""
                    }
                    onClick={() => navigate(FOSA_VERIFICATION)}
                  >
                    <Button startIcon={<FingerprintOutlinedIcon />}>
                      {t("verificationTitle")}
                    </Button>
                  </li>
                )}

                {HAS_PERMISSION_TO_VIEW_PAGE(
                  PATH_NAME_PERMISSIONS,
                  Pre_Autharization,
                  currentUserRoles
                ) && (
                  <li
                    className={
                      location.pathname.includes(
                        Pre_Autharization || Pre_Autharization_Form
                      )
                        ? "active"
                        : ""
                    }
                    onClick={() => navigate(Pre_Autharization)}
                  >
                    <Button startIcon={<VerifiedUserIcon />}>
                      {t("preAuthAgreements")}
                    </Button>
                  </li>
                )}

                {HAS_PERMISSION_TO_VIEW_PAGE(
                  PATH_NAME_PERMISSIONS,
                  ADMIN_USERS,
                  currentUserRoles
                ) && (
                  <li
                    className={
                      location.pathname.includes(
                        ADMIN_USERS || ADMIN_USER_FORM || ADMIN_USER_FORM_BY_ID
                      )
                        ? "active"
                        : ""
                    }
                    onClick={() => navigate(ADMIN_USERS)}
                  >
                    <Button startIcon={<ManageAccountsIcon />}>
                      {t("adminManagement.title")}
                    </Button>
                  </li>
                )}
              </>
            )}
          </>
        )}
        {/* Add more menu items as needed */}
      </ul>
    </div>
  );
};

export default Sidebar;
